import { render, staticRenderFns } from "./Ethos.vue?vue&type=template&id=79291468&"
import script from "./Ethos.vue?vue&type=script&lang=js&"
export * from "./Ethos.vue?vue&type=script&lang=js&"
import style0 from "./Ethos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports